import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'cue-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ModalComponent {
  modal = input<DialogRef>();
  close = output();

  onClose() {
    if (this.modal()) {
      this.modal()!.close(0);
    } else {
      this.close.emit(null);
    }
  }
}
